export enum SettingsSection {
  PayId = "pay-ids",
  AddressBook = "address-book",
  BusinessUsers = "business-users",
}
